import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLFormElement> {
  static values = {
    loading: Boolean,
    disableWithDelay: { type: Number, default: 500 },
  };

  timeoutId?: ReturnType<typeof setTimeout>;

  declare loadingValue: boolean;
  declare disableWithDelayValue: number;
  declare readonly hasLoadingValue: boolean;
  declare readonly hasDisableWithDelayValue: boolean;

  connect() {
    this.element.addEventListener("submit", this.maybeSubmit);
  }

  disconnect(): void {
    if (this.timeoutId) clearTimeout(this.timeoutId);
    this.element.removeEventListener("submit", this.maybeSubmit);
  }

  maybeSubmit = (event: SubmitEvent) => {
    if (this.loadingValue) {
      event.preventDefault();
      return false;
    }
    this.loadingValue = true;
    this.disableWith(event);
  };

  disableWith(event: SubmitEvent) {
    const submitter = event.submitter;
    const disableWithContent = submitter?.dataset.disableWith;
    submitter?.setAttribute("disabled", "");
    this.timeoutId = setTimeout(() => {
      if (submitter && disableWithContent) {
        if (submitter instanceof HTMLInputElement) {
          submitter.value = disableWithContent;
        } else {
          submitter.innerHTML = disableWithContent;
        }
      }
    }, this.disableWithDelayValue);
  }
}
